import React from 'react'
import { useIsFocused, useLocalSearchParams, useRouter } from 'expo-router'
import { Text, TouchableOpacity, View } from 'react-native'
import { diceLuckPercentile, diceLuckVerdict, type DiceLuckResult } from '@warcarp/api-types'
import { DiceLuckModal } from '../../../components/game/DiceLuckModal'
import { GameTopBar } from '../../../components/game/GameTopBar'
import { game } from '../../../preview/fixtures/cardBonusOnly'

// Synthetic, offline aggregates for layout QA; not a reconstruction of a real game.
const cases = [
  { name: 'SlickedUp', swing: 22.7, variance: 420, rolls: 224 },
  { name: 'achilles282', swing: 6.8, variance: 280, rolls: 137 },
  { name: 'TurtleTom79', swing: -4.7, variance: 36, rolls: 19 },
  { name: 'Hannibal', swing: -6.3, variance: 28, rolls: 14 },
  { name: 'yakuza', swing: -22.3, variance: 260, rolls: 131 },
  { name: 'unsay', swing: -18.2, variance: 92, rolls: 51 },
]
const players = cases.map((row, index) => ({
  ...game.players[0]!, id: `preview-${index}`, slot: index + 1, displayName: row.name,
}))
const result: DiceLuckResult = {
  skippedRolls: 0,
  players: cases.map((row, index) => {
    const zScore = row.swing / Math.sqrt(row.variance)
    const series = Array.from({ length: row.rolls }, (_, i) => row.swing * (i + 1) / row.rolls)
    return {
      playerId: String(index + 1), rollCount: row.rolls,
      attackRollCount: row.rolls, defenseRollCount: 0,
      netSwing: row.swing, attackSwing: row.swing, defenseSwing: 0,
      variance: row.variance, zScore,
      percentile: diceLuckPercentile(zScore, row.rolls), verdict: diceLuckVerdict(zScore, row.rolls),
      series, attackSeries: series, defenseSeries: series.map(() => 0),
      varianceSeries: series.map((_, i) => row.variance * (i + 1) / row.rolls),
      seriesEvents: series.map((_, i) => ({ eventIndex: i, ts: 1_790_000_000_000 + i * 1000 })),
      bestRoll: null, worstRoll: null,
    }
  }),
}

export default function DiceLuckPreview() {
  const { complete } = useLocalSearchParams<{ complete?: string }>()
  const router = useRouter()
  const focused = useIsFocused()
  const [visible, setVisible] = React.useState(!complete)
  return (
    <View className="flex-1 bg-canvas">
      {complete && <GameTopBar gameId="preview" status="COMPLETE" state={null} players={players}
        canResign={false} activityOpen={false} onOpenPlayers={() => {}}
        onToggleActivity={() => {}} onBack={() => router.replace('/preview')}
        onShowDiceLuck={() => setVisible(true)} />}
      <TouchableOpacity accessibilityRole="button" accessibilityLabel="Open fixture dice luck" onPress={() => setVisible(true)}>
        <Text className="text-ink">Open fixture dice luck</Text>
      </TouchableOpacity>
      <DiceLuckModal visible={visible && focused} onClose={() => setVisible(false)} players={players}
        viewerPlayerId="5" initialPlayerId="6" map={null} result={result} snapshot={null}
        canGoLive={false} isLive={false} lastUpdatedAt={null} loading={false} error={false}
        unavailable={false} onGoLive={() => {}} onViewEvent={() => {}} />
    </View>
  )
}
